import { TextField, styled } from "@mui/material";

export const ErrorTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    "& fieldset": {
      borderColor: (props: { error: boolean }) =>
        props.error && theme.palette.error.main,
    },
    "&:hover fieldset": {
      borderColor: (props: { error: boolean }) =>
        props.error && theme.palette.error.main,
      borderWidth: "2px",
    },
    "&:focus fieldset": {
      borderColor: (props: { error: boolean }) =>
        props.error && theme.palette.error.main,
      borderWidth: "2px",
    },
  },
}));
